import React from "react"
import { useRouter } from "next/router"
import { getRedditAppInstallUrl, getRedditAuthorizationLink } from "../../utils/reddit"
import { Button, ButtonTheme } from "../formElements/button"
import { ReactComponent as RedditIcon } from "../../assets/icons/reddit-black.svg"
import { ReactComponent as RedditIconWhite } from "../../assets/icons/reddit.svg"
import { useTranslation } from "next-i18next"

interface ConnectRedditProps {
  label?: string
  questionId?: string
}

export const LoginReddit = ({ label }: ConnectRedditProps) => {
  const router = useRouter()
  const { t } = useTranslation("reddit")
  return (
    <Button
      action={label ?? t("connect.action")}
      icon={<RedditIconWhite />}
      theme={ButtonTheme.Warning}
      iconBefore={true}
      onClickAsync={async () => {
        const url = getRedditAuthorizationLink()
        await router.push(url)
      }}
    />
  )
}

export const ConnectReddit = ({ label }: ConnectRedditProps) => {
  const router = useRouter()
  const { t } = useTranslation("reddit")
  return (
    <Button
      action={label ?? t("connect.action")}
      icon={<RedditIcon />}
      theme={ButtonTheme.PrimaryOutline}
      iconBefore={true}
      onClickAsync={async () => {
        const url = getRedditAuthorizationLink()
        await router.push(url)
      }}
    />
  )
}

export const InstallAppButton = () => {
  const router = useRouter()
  const { t } = useTranslation("reddit")
  return (
    <Button
      action={t("install_app.install_button")}
      icon={<RedditIcon />}
      theme={ButtonTheme.WarningOutline}
      iconBefore={true}
      onClickAsync={async () => {
        const url = getRedditAppInstallUrl()
        await router.push(url)
      }}
    />
  )
}
